module.exports = "<section class=\"card shadow-sm mb-2 p-3 suggestions\">\n  <app-client-suggestions></app-client-suggestions>\n</section>"